<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleInfo, faTriangleExclamation, faCircleCheck, faCalendarDays, faBullhorn } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import EGS_Tooltip from '@/components/Tooltip/Tooltip.vue';
import type { AnnouncementContent } from '@/store/announcementsStore';

defineProps<{ content: AnnouncementContent; preview?: boolean }>();
const icons: Record<string, IconDefinition> = { 'circle-info': faCircleInfo, 'triangle-exclamation': faTriangleExclamation, 'circle-check': faCircleCheck, 'calendar-days': faCalendarDays, bullhorn: faBullhorn };
</script>

<template>
	<div class="flex flex-wrap items-center gap-x-2 gap-y-1">
		<span class="whitespace-pre-wrap break-words">{{ content.message }}</span>
		<EGS_Tooltip v-for="(icon, index) in content.icons" :key="`icon-${index}`" :text="icon.hover" position="bottom">
			<span tabindex="0" role="img" :aria-label="icon.hover" class="inline-flex cursor-help rounded focus-visible:outline focus-visible:outline-2"><FontAwesomeIcon :icon="icons[icon.name] || faCircleInfo" /></span>
		</EGS_Tooltip>
		<EGS_Tooltip v-for="(link, index) in content.links" :key="`link-${index}`" :text="link.hover" :disabled="!link.hover" position="bottom">
			<span v-if="preview" class="font-bold text-cyan-900 underline dark:text-cyan-200">{{ link.label }}</span>
			<router-link v-else :to="link.route" class="font-bold text-cyan-900 underline hover:no-underline dark:text-black-200">{{ link.label }}</router-link>
		</EGS_Tooltip>
	</div>
</template>
